import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useLoginAppUrl } from '@xing-com/crate-xinglet';

import { upltTrackingParameters } from '../../constants';
import type { ProductType } from '../../typings/types';
import { useSearchParameters } from '../../utils/use-search-parameters';

/**
 * We want to direct the user to the product page if he is logged in
 * if logged out we want to login/register and then send to the product page
 * the user can reach this page (/purchase/products) if he arrives at a specific
 * product page without being logged in.
 *
 * @param product - Premium or Projobs
 * @returns either a direct link to product page or with a login before that.
 * @example
 * const link = useCustomLink('premium');
 */
const useCustomLink = (product: ProductType): string => {
  const { getAllSearchParameters } = useSearchParameters();
  const searchParameters = getAllSearchParameters();
  const { isLoggedOut } = useLoginState();
  const loginAppUrl = useLoginAppUrl();
  const trackingParams = `sc_o=upsellfunnel_products_welcome_go_${product}_click&reagent=${
    upltTrackingParameters.GO_TO_PRODUCT_BTN[product]
  }${searchParameters ? `&${searchParameters}` : ''}`;

  const linkForLoggedIn = `/purchase/${product}?${trackingParams}`;
  const linkForLoggedOut = `${loginAppUrl}?&dest_url=/purchase/${product}&${trackingParams}`;

  return isLoggedOut ? linkForLoggedOut : linkForLoggedIn;
};

export default useCustomLink;
